import * as React from "react";
import clsx from "clsx";
import { useLocation } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import MuiLink from "@material-ui/core/Link";

function Link(props) {
  const {
    href,
    activeClassName = "active",
    className: classNameProps,
    innerRef,
    disabled = false,
    ...other
  } = props;

  const location = useLocation();
  const pathname = typeof href === "string" ? href : href.pathname;
  const className = clsx(classNameProps, {
    [activeClassName]: location.pathname === pathname && activeClassName,
  });

  if (disabled) {
    return (
      <div
        component="a"
        variant="body2"
        className={className}
        ref={innerRef}
        {...other}
      />
    );
  }

  return (
    <MuiLink
      component={RouterLink}
      className={className}
      ref={innerRef}
      href={href}
      to={href}
      {...other}
    />
  );
}

export default React.forwardRef((props, ref) => (
  <Link {...props} innerRef={ref} />
)) as any;
